import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
const DetailAction = (props) => {
    const { disabled, onClickReview, order, showModalConfirmOrder, showModalConfirmSendOff, } = props;
    const { professionalStatus } = order;
    if (professionalStatus <= 1) {
        return (_jsxs("div", Object.assign({ className: 'detail-action' }, { children: [_jsx("button", Object.assign({ className: 'btn btn-primary small', disabled: disabled, onClick: showModalConfirmOrder, type: 'button' }, { children: "\u53D7\u6CE8" })), _jsx("button", Object.assign({ className: 'btn btn-primary small', disabled: disabled, onClick: showModalConfirmSendOff, type: 'button' }, { children: "\u898B\u9001\u308A" }))] })));
    }
    if (professionalStatus === 2) {
        return (_jsx("button", Object.assign({ className: 'btn btn-tertiary small is-disabled', disabled: true, type: 'button' }, { children: "\u898B\u9001\u308A\u6E08" })));
    }
    // review.
    const isReviewed = !!order.review;
    const valuation = _.get(order.review, 'valuation');
    const setStyle = {
        1: '20%',
        2: '40%',
        3: '60%',
        4: '80%',
        5: '100%',
    };
    return (_jsxs("div", Object.assign({ className: 'detail-action review' }, { children: [_jsxs("div", Object.assign({ className: 'review-star' }, { children: [_jsx("div", Object.assign({ className: 'star-rating-front', style: { width: setStyle[valuation] || '0%' } }, { children: "\u2605\u2605\u2605\u2605\u2605" })), _jsx("div", Object.assign({ className: 'star-rating-back' }, { children: "\u2605\u2605\u2605\u2605\u2605" }))] })), _jsx("button", Object.assign({ className: 'btn btn-secondary small modalBtn', onClick: onClickReview, type: 'button' }, { children: isReviewed ? 'レビューを見る' : 'レビュー' }))] })));
};
DetailAction.propTypes = {
    disabled: propBool().isRequired,
    onClickReview: propFunc().isRequired,
    order: propShape().isRequired,
    showModalConfirmOrder: propFunc().isRequired,
    showModalConfirmSendOff: propFunc().isRequired,
};
export default DetailAction;
